module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1047-143851055e1efad239cb8b2629eae0a5.png";